import React, { useContext, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import Verify from '../common/Verify';
import routes from '../../../Constants/routes';
import { requestOneTimeOtp, verifyOneTimeOTP } from '../api';
import { useSnackbar } from 'notistack';
import { AuthContext } from '../../../Context/authContext';
import AuthLayout from '../AuthLayout';
import KenLoader from '../../../Components/KenLoader';

export default function VerifyEmail() {
  const navigate = useNavigate();
  const { dispatch } = useContext(AuthContext);
  const { state: navigateState } = useLocation();
  const { enqueueSnackbar } = useSnackbar();

  const [loading, setLoading] = useState(false);
  const [otp, setOtp] = useState('');

  const onSubmit = async ({ otp: { otp } }) => {
    setLoading(true);
    try {
      const payload = {
        email: navigateState.email,
        otp: otp,
        applicant: { ...navigateState },
        accountId: navigateState.accountId
      };
      const res = await verifyOneTimeOTP(payload);

      if (!res || !res?.success) {
        setOtp(null);
        return enqueueSnackbar(res?.errorMessage || 'Something went wrong', {
          variant: 'error',
        });
      }

      dispatch({
        type: 'LOGIN',
        payload: {
          user: {
            id: res?.contactId,
            applicantEmail: res?.contactEmail,
            applicantId: res?.contactId,
            applicantName:
              navigateState?.firstName + ' ' + navigateState?.lastName,
            accessToken: {
              accessToken: res?.accessToken,
            },
            refreshToken: {
              refreshToken: res?.refreshToken,
            },
            prog: navigateState?.program,
          },
        },
      });
    } catch (error) {
      const errorMessage =
        error && error?.response?.data?.errorMessages
          ? Array.isArray(error?.response?.data?.errorMessages) &&
            error?.response?.data?.errorMessages[0]?.errorMessage
          : error?.response?.data?.errorMessage || 'Something went wrong';
      if (
        errorMessage.includes('Email already exists') ||
        errorMessage.includes('duplicate record')
      ) {
        setOtp(null);
        setTimeout(() => {
          navigate(routes.login);
        }, 2000);
      }
      setLoading(false);
      return enqueueSnackbar(errorMessage, {
        variant: 'error',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    const res = await requestOneTimeOtp({
      id: navigateState.email,
      phone: navigateState?.phone,
    });

    return res;
  };

  return (
    <>
      {loading && <KenLoader />}
      <AuthLayout>
        <Verify
          loading={loading}
          from="verifyEmail"
          title="Verify Your Email"
          subTitle={
            <>
              <span>
                Please enter the OTP sent to your registered Email ID.
              </span>
            </>
          }
          submitText="Verify & Sign Up"
          onVerify={(otp) => {
            onSubmit({ otp });
          }}
          handleResendOtp={handleResendOtp}
          otp={otp}
          setOtp={setOtp}
        />
      </AuthLayout>
    </>
  );
}
